import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    labelText: {
      color: theme.palette.grey[500]
    },
    valueText: {
      fontWeight: 500
    }
  };
});

type WeekRangeProps = {
  start: number;
  end: number;
};

const WeekRange: React.FC<WeekRangeProps> = ({ start, end }) => {
  const classes = useStyles();

  return (
    <>
      <Typography component="span" className={classes.valueText}>
        Week {start}
      </Typography>
      <Typography style={{ marginLeft: 8 }} component="span" className={classes.labelText}>
        of {end}
      </Typography>
    </>
  );
};

export default WeekRange;
